import Icon from 'components/Icon/Icon.component';
import colors from 'style-utils/colors';
import { fadeIn } from 'style/keyframes';
import styled, { keyframes } from 'styled-components';
import { LoaderProps } from '../Loader.types';

export const LoaderContainer = styled.div<
  Pick<LoaderProps, 'viewMode' | 'active'>
>`
  position: relative;

  ${function manageViewMode({ viewMode = 'inline' }): string {
    switch (viewMode) {
      case 'fluid':
        return `
          display: block;
          width: 100%;
        `;
      case 'fullSize':
        return `
            display: block;
            width: 100%;
            height: 100%;
        `;
      case 'absolute':
        return `
          display: block;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          z-index: 51;
          pointer-events: none;
        `;
      case 'inline':
        return `
          display: inline-block;
        `;
    }
  }};
`;

export const OverlayContainer = styled.div<
  Pick<LoaderProps, 'overlayViewMode' | 'active' | 'animationDelayMs'>
>`
  position: ${({ overlayViewMode }) =>
    overlayViewMode === 'fullscreen' ? 'fixed' : 'absolute'};
  width: 100%;
  height: 100%;
  background: ${colors.loaderBg};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  z-index: ${({ overlayViewMode }) =>
    overlayViewMode === 'fullscreen' ? '999' : '10'};
  animation: ${fadeIn} 200ms linear;
  animation-fill-mode: both;
  animation-direction: ${({ active }) => (active ? 'normal' : 'reverse')};
  animation-delay: ${({ animationDelayMs = 0 }) => `${animationDelayMs}ms`};
`;

export const OverlayIcon = styled.div`
  position: absolute;
  height: 60px;
  width: 60px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

export const LoaderIconWrapper = styled(Icon)`
  animation: ${rotate} 1200ms linear infinite;
`;
